import axios from 'axios';
import { ROOT_URL, getAuthHeaders } from './constants';

/**
 * Obtiene el estado de todos los servicios desde el backend.
 * El backend expone un único endpoint que entrega esta información consolidada.
 *
 * @export getAllServicesStatus
 * @async
 * @returns {Promise<Object>} Objeto con el estado de los servicios y timestamp
 */
export async function getAllServicesStatus() {
  try {
    const hasAuth = sessionStorage.getItem('authenticationToken') && sessionStorage.getItem('email');
    const config = hasAuth ? getAuthHeaders() : {};
    const response = await axios.get(`${ROOT_URL}/health_check`, config);
    
    if (response.status === 200) {
      const data = response.data;

      return {
        backend: data.backend ? 'online' : 'offline',
        mongodb: data.mongo ? 'online' : 'offline',
        postgresql: data.postgres ? 'online' : 'offline',
        centroEspanolApi: data.centro_espanol_api ? 'online' : 'offline',
        overallStatus: data.status || 'offline',
        activeUsers: data.active_users || 0,
        version: data.version || 'N/A',
        timestamp: new Date().toLocaleTimeString()
      };
    }
    return {
      backend: 'offline',
      mongodb: 'offline',
      postgresql: 'offline',
      centroEspanolApi: 'offline',
      overallStatus: 'offline',
      version: 'N/A',
      activeUsers: 0,
      timestamp: new Date().toLocaleTimeString()
    };
  } catch (error) {
    console.error('Error al verificar servicios:', error);
    return {
      backend: 'offline',
      mongodb: 'offline',
      postgresql: 'offline',
      centroEspanolApi: 'offline',
      overallStatus: 'offline',
      activeUsers: 0,
      version: 'N/A',
      timestamp: new Date().toLocaleTimeString()
    };
  }
}